import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const FinalCTA = () => {
  const { t, lang } = useLanguage();

  const trackContact = (actionName) => {
    if (window.fbq) {
      window.fbq('track', 'Contact', {
        language: lang,
        action: actionName
      });
    }
  };

  return (
    <section className="py-24 bg-white border-t border-slate-100 text-center">
      <div className="container-custom">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-3xl mx-auto"
        >
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6">
            {t.cta.title}
          </h2>
          <p className="text-xl text-slate-600 mb-10">
            {t.cta.desc}
          </p>
          
          <div className="flex flex-col sm:flex-row flex-wrap justify-center items-center gap-4">
            <a 
              href="#contact"
              onClick={() => trackContact('Request a Tour')}
              className="btn-primary w-full sm:w-auto px-8 py-4 text-lg"
            >
              {t.cta.btn}
            </a>
            
            <a 
              href="https://www.google.com/maps/dir/?api=1&destination=7429%20NW%20182nd%20St%2C%20Hialeah%2C%20FL%2033015" 
              target="_blank" 
              rel="noopener noreferrer" 
              aria-label={t.cta.directionsAria}
              onClick={() => trackContact('Get Directions')}
              className="btn-primary w-full sm:w-auto px-8 py-4 text-lg flex items-center justify-center"
            >
              <SafeIcon name="MapPin" className="mr-2 w-5 h-5" />
              {t.cta.directions}
            </a>
            
            <div className="flex w-full sm:w-auto gap-4">
              <a 
                href="tel:+17865291915" 
                onClick={() => trackContact('Call')}
                className="btn-secondary flex-1 sm:flex-none justify-center"
              >
                <SafeIcon name="Phone" className="mr-2 w-5 h-5 flex-shrink-0" />
                {t.cta.call}
              </a>
              <a 
                href="sms:+17865291915" 
                onClick={() => trackContact('Text')}
                className="btn-secondary flex-1 sm:flex-none justify-center"
              >
                <SafeIcon name="MessageSquare" className="mr-2 w-5 h-5 flex-shrink-0" />
                {t.cta.text}
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;